import type { RouteRecordRaw } from 'vue-router';

/**
 * Payroll web screens (M8, DECISIONS.md "ADR-089 — Payroll (M8, WP8.6)"). Follows the parallel-work
 * convention of `quality.ts`/`planning.ts`: `router.ts` only spreads this array into the app-shell children.
 */
export const payrollRoutes: RouteRecordRaw[] = [
  {
    path: 'payroll/components',
    name: 'payroll-components',
    component: () => import('../pages/payroll/PayrollComponentsPage.vue'),
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/structures',
    name: 'payroll-structures',
    component: () => import('../pages/payroll/PayrollStructuresPage.vue'),
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/assignments',
    name: 'payroll-assignments',
    component: () => import('../pages/payroll/PayrollAssignmentsPage.vue'),
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/periods',
    name: 'payroll-periods',
    component: () => import('../pages/payroll/PayrollPeriodsPage.vue'),
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/runs',
    name: 'payroll-runs',
    component: () => import('../pages/payroll/PayrollRunsPage.vue'),
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/runs/:id',
    name: 'payroll-run-detail',
    component: () => import('../pages/payroll/PayrollRunDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'payroll' },
  },
  {
    path: 'payroll/payslips/:id',
    name: 'payroll-payslip',
    component: () => import('../pages/payroll/PayslipPage.vue'),
    props: true,
    meta: { requiresModule: 'payroll' },
  },
];
